import { SET_CAREER_DATA } from "../actions/careerActions";

const initialState = {
  data: null,
  status: "idle",
  error: null,
};

const careerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAREER_DATA:
      return { ...state, data: action.payload, status: "success" };
    default:
      return state;
  }
};

export default careerReducer;
